/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useState } from "react";
import HtmlContent from "../../components/HTMLContent";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../components/ui/accordion";
import { API, get } from "../../config";
import MainBody from "../../components/MainBody/MainBody";
import { Button } from "../../components/ui/button";
import { Play } from "lucide-react";

const FAQList = ({ type }) => {
  const [activeId, setActiveId] = useState();
  const [faqListData, setFaqListData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleAccordionChange = async (value) => {
    if (!value) {
      setActiveId(null);
      return;
    }

    setActiveId(value);
  };

  const fetchFAQsData = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await get(`${API.GET_FAQ_LIST}?type=${type}&limit=-1`);
      let activet = data?.data;

      if (activet?.[0]?.id !== undefined) {
        setActiveId(activet?.[0]?.id);
      }
      setFaqListData(data?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setFaqListData([]);
    }
  }, [type]);

  useEffect(() => {
    fetchFAQsData();
  }, [fetchFAQsData]);

  return (
    <>
      <MainBody
        search={false}
        loading={loading}
        innerBody={true}
        actionAlign={"start"}
        actionContent={""}
      >
        {/* Add Video */}
        <div className="flex items-center justify-between rounded-md border border-webPrimary bg-webSecondary p-3 mb-2">
          <p className="text-sm font-medium text-white">
            Please watch this short video on the TrustEasy AML solution:
          </p>

          <Button
            className="hover:bg-webPrimary"
            onClick={() =>
              window.open(type == 1 ? 'https://share.synthesia.io/a75052fa-2199-42c9-92c9-fc46f0bd4134' : 'https://share.synthesia.io/00c57a17-d30b-4bdc-9788-b6233a10dfe2',  "_blank", "noopener,noreferrer")
            }
          >
            Watch Video
            <Play className="ml-1 h-4 w-4" />
          </Button>
        </div>
        <Accordion
          type="single"
          collapsible
          value={activeId}
          onValueChange={handleAccordionChange}
          className="w-full"
        >
          {faqListData.map((item) => {
            return (
              <AccordionItem
                key={item?.id}
                value={item?.id}
                className="border-none"
              >
                <AccordionTrigger
                  className="group text-sm p-3 border bg-muted hover:bg-webSecondary hover:[&>svg]:text-white hover:text-white data-[state=open]:bg-webPrimary hover:no-underline data-[state=open]:text-white [&[data-state=open]>svg]:text-white"
                  iconClassName={
                    "text-black dark:text-white group-hover:text-white"
                  }
                >
                  <>
                    <div className="mr-3 h-5 w-5 flex items-center justify-center text-sm">
                      {item?.order}
                    </div>
                    <div className="flex items-center justify-between w-full pr-3">
                      {item?.question}
                    </div>
                  </>
                </AccordionTrigger>
                <AccordionContent>
                  <div className={"text-md border p-4 border-t-0"}>
                    <HtmlContent html={item?.answer} />
                  </div>
                </AccordionContent>
              </AccordionItem>
            );
          })}
        </Accordion>
      </MainBody>
    </>
  );
};

export default FAQList;
